module.exports = __webpack_public_path__ + "static/media/LL_9789065449054.a283741d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/LL_9789065449054.jpg
// module id = 1763
// module chunks = 1